import React from 'react';
import colors from '../../../Theming/colors';
import { SvgProps, useDefaultColor } from '../core';

const Hamburger: React.FC<SvgProps> = ({
  color = colors.darkestGrey,
  width = 24,
  height = 24,
  style,
  className,
}) => {
  const resolvedColor = useDefaultColor(color);

  return (
    <svg
      style={style}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        d="M23.207 11H1.293C.58 11 0 11.457 0 12.022v.107c0 .565.579 1.022 1.293 1.022h21.914c.714 0 1.293-.457 1.293-1.021v-.108c0-.565-.579-1.022-1.293-1.022zM23.207 16H1.293C.58 16 0 16.457 0 17.022v.108c0 .564.579 1.021 1.293 1.021h21.914c.714 0 1.293-.457 1.293-1.021v-.108c0-.564-.579-1.022-1.293-1.022zM23.207 6H1.293C.58 6 0 6.458 0 7.022v.107c0 .565.579 1.022 1.293 1.022h21.914c.714 0 1.293-.457 1.293-1.021v-.108C24.5 6.458 23.921 6 23.207 6z"
        fill={resolvedColor}
      />
    </svg>
  );
};

export default Hamburger;
